import { render, staticRenderFns } from "./Xiaomi12tImage3.vue?vue&type=template&id=62c96083&scoped=true&"
import script from "./Xiaomi12tImage3.vue?vue&type=script&lang=js&"
export * from "./Xiaomi12tImage3.vue?vue&type=script&lang=js&"
import style0 from "./Xiaomi12tImage3.vue?vue&type=style&index=0&id=62c96083&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c96083",
  null
  
)

export default component.exports